import { Grid, FormControlLabel, Switch } from '@mui/material'

const SwitchLabel = ({
  xs,
  md,
  title,
  index,
  name,
  typePage,
  value,
  disabled,
  labelPlacement = 'end',
  register,
  trigger,
  onChange,
  ...props
}) => {
  const registration = name && register ? register(name) || {} : {}

  return (
    <Grid item xs={xs} md={md}>
      <FormControlLabel
        label={title}
        labelPlacement={labelPlacement}
        control={
          <Switch
            {...props}
            {...registration}
            name={name}
            checked={Boolean(value)}
            disabled={disabled}
            onChange={(e) => {
              registration.onChange?.(e)
              onChange?.(e.target.checked)
            }}
          />
        }
        size="small"
        sx={{
          '&:hover': {
            '& .MuiFormControlLabel-label': {
              color: 'primary.main',
            },
          },
        }}
      />
    </Grid>
  )
}

export default SwitchLabel
